export default __webpack_public_path__ + "static/media/loading3.c8d58a31.gif";